module.exports = "/images/user.jpg?157750baa193ff08d4b638883781c5e6";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/user.jpg
// module id = lDfq
// module chunks = 0